import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';

import Loader from '../../../../../../common/loader/loader';
import { nortadaLogger } from '../../../../../../common/logger';
import { DialogError } from '../../../../../../common/business-error';

import {
  PAYMENT_STATUSES,
  WalletCreditInfoResponse
} from '../../../../client-balance/add-funds-to-your-wallet/interfaces';
import { ConfirmedCredit, RejectedCredit, PendingCredit } from './credits';

interface Props {
  credit: WalletCreditInfoResponse | null;
  loading: boolean;
  error: DialogError;
  handleClose: () => void;
}

const CreditDetails = ({ credit, loading, error, handleClose }: Props) => {
  if (loading) {
    return (
      <Box width="100%" height="100%">
        <Loader />
      </Box>
    );
  }

  if (error) {
    return <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>;
  }

  if (credit) {
    switch (credit.info.creditStatus) {
      case PAYMENT_STATUSES.CONFIRMED: {
        return <ConfirmedCredit credit={credit} />;
      }
      case PAYMENT_STATUSES.REJECTED: {
        return <RejectedCredit credit={credit} />;
      }
      case PAYMENT_STATUSES.PENDING: {
        return <PendingCredit credit={credit} handleClose={handleClose} />;
      }
      default: {
        nortadaLogger.critical(
          `Error in Wallet credits history details.
          ${credit.status} is not supported credit status.
          Should be Confirmed, Rejected or Pending.`
        );
        return (
          <AlertBoxMsg severity="error">
            Error! Unexpected credit status. Please refresh page and try again. If the problem still persists, contact
            with support.
          </AlertBoxMsg>
        );
      }
    }
  }

  return null;
};

export default CreditDetails;
